import * as React from "react";
import { Link, navigate } from "gatsby";
import "./header.css";
import { useContactModal } from "./contact-modal-context";

const INTRO_REPLAY_EVENT = "kika:intro:replay";
const INTRO_REQUEST_REPLAY_EVENT = "kika:intro:request-replay";

export default function Header() {
  const { openContact, isOpen } = useContactModal();

  const onTitleClick = React.useCallback((e) => {
    e.preventDefault();
    navigate("/", { replace: true });

    if (typeof window !== "undefined") {
      window.dispatchEvent(new Event(INTRO_REQUEST_REPLAY_EVENT));
    }
  }, []);

  return (
    <header className="site-header" role="banner">
      <div className="header-left">
        <Link
          to="/"
          className="site-title serif"
          aria-label="Home"
          onClick={onTitleClick}
        >
          Kika Karadi
        </Link>
      </div>

      <div className="header-right">
        <nav className="site-nav" aria-label="Primary">
          <Link to="/" activeClassName="active">
            Work
          </Link>

          <Link to="/bio" activeClassName="active">
            Bio
          </Link>

          <button
            type="button"
            className={`site-nav__button ${isOpen ? "active" : ""}`}
            onClick={openContact}
            aria-haspopup="dialog"
            aria-expanded={isOpen}
          >
            Contact
          </button>
        </nav>
      </div>
    </header>
  );
}
